import { render, staticRenderFns } from "./PreviewCodeTest.vue?vue&type=template&id=813acace"
import script from "./PreviewCodeTest.vue?vue&type=script&lang=js"
export * from "./PreviewCodeTest.vue?vue&type=script&lang=js"
import style0 from "./PreviewCodeTest.vue?vue&type=style&index=0&id=813acace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports